import React, { ReactNode } from 'react'
import './menufolder.css';

interface Props {
    desc       : string;
    id         : string;
    children   : ReactNode | ReactNode[];
    showFolder : (id : string, show : boolean) => void;
    show?      : boolean;
}

interface State {
    show : boolean;
}

export class MenuFolder extends React.Component<Props, State> {

    constructor(props : Props)
    {
        super(props);

        this.state = {
            show : false
        };
    }

    handleClick()
    {
        this.props.showFolder(this.props.id, !this.props.show);
    }

    setIsHovered(hover : boolean)
    {
        this.props.showFolder(this.props.id, hover);
    }

    render() {
        return (
            <li className={`menu-item menu-item-folder${this.props.show ? ' show' : ''}`} onClick={ () => this.handleClick()} onMouseEnter={() => this.setIsHovered(true)} onMouseLeave={() => this.setIsHovered(false)} >
                <div>
                    <div className="menu-link">{ this.props.desc }</div>
                </div>
                { this.props.show &&
                    <ul className="menu-dropdown">
                        {this.props.children}
                    </ul>
                }
            </li>
        );
    }
}

